import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
interface PurchaseToastProps {
  isVisible: boolean;
  name: string;
  city: string;
  productTitle: string;
  editionLabel: string;
  priceText: string;
  thumbnailUrl: string;
}
export function PurchaseToast({
  isVisible,
  name,
  city,
  productTitle,
  editionLabel,
  priceText,
  thumbnailUrl
}: PurchaseToastProps) {
  // Check for reduced motion preference
  const prefersReducedMotion = typeof window !== 'undefined' ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
  const animationVariants = prefersReducedMotion ? {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  } : {
    initial: {
      opacity: 0,
      y: 50,
      scale: 0.95
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1
    },
    exit: {
      opacity: 0,
      y: 20,
      scale: 0.95
    }
  };
  return <AnimatePresence data-id="element-329">
      {isVisible && <motion.div initial={animationVariants.initial} animate={animationVariants.animate} exit={animationVariants.exit} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:bottom-4 z-50 sm:max-w-[340px]" data-id="element-330">
          <div className="bg-white/95 backdrop-blur-md rounded-2xl shadow-lg border border-gold/20 p-2.5 flex items-center gap-2.5" data-id="element-331">
            {/* Product Image */}
            <div className="flex-shrink-0" data-id="element-332">
              <img src={thumbnailUrl} alt={productTitle} className="w-10 h-10 rounded-lg object-cover" data-id="element-333" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0 overflow-hidden" data-id="element-334">
              <div className="flex items-center gap-1 mb-0.5" data-id="element-335">
                <ShoppingBag className="w-3 h-3 text-gold flex-shrink-0" data-id="element-336" />
                <p className="text-[10px] font-semibold text-navy uppercase tracking-wide" data-id="element-337">
                  Recent Purchase
                </p>
              </div>
              <p className="text-xs text-charcoal leading-tight line-clamp-2" data-id="element-338">
                <span className="font-semibold" data-id="element-339">{name}</span> in {city}{' '}
                purchased {editionLabel} —{' '}
                <span className="font-bold text-gold" data-id="element-340">{priceText}</span>
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}